letterAdjust.y = 2.5;
// Colors are in order like this...  home: [ inside, outline, outline2, outline3 ]
var font = {
    ".": "M200-266v208h208v-208H200z",
    "0": "M427.786 1024l138.112-138.112v-747.777l-138.112-138.112h-289.691l-138.095 138.112v747.86l138.095 138.112zM350.307 798.32l-10.038 10.038h-114.588l-10.038-10.038v-572.64l10.038-10.038h114.521l10.038 10.038z",
    "1": "M282.949 215.575v808.425h-158.322l-124.627-124.643v-158.305h67.374v-525.477h-67.374v-215.575h350.307v215.575h-67.358z",
    "2": "M565.898 309.885v-309.885h-565.898v495.161l138.112 137.961 202.090 0.134 10.105 10.105v154.959l-10.105 10.105h-114.521l-10.105-10.105v-70.737h-215.575v158.305l138.112 138.112h289.675l138.112-138.112v-330.096l-138.112-138.112h-202.106l-10.105-10.105v-192.001h134.732v94.311h215.591z",
    "3": "M565.898 885.888l-138.112 138.112h-289.675l-138.112-138.112v-158.305h215.575v70.737l10.105 10.105h114.538l10.105-10.105v-154.959l-10.105-10.105h-138.095v-215.575h138.095l10.105-10.105v-181.896l-10.105-10.105h-114.538l-10.105 10.105v84.205h-215.575v-171.774l138.112-138.112h289.675l138.112 138.112v343.564l-43.801 43.801 43.801 43.784v316.628z",
    "4": "M668.624 215.575h-67.358v-215.575h-215.591v215.575h-287.985l-97.69 195.381 306.522 613.045h294.744v-592.851h67.358zM385.675 431.149v272.844l-136.388-272.844z",
    "5": "M565.898 727.583v296.417h-565.898v-468.207l138.112-137.978 202.090-0.134 10.105-10.105v-181.896l-10.105-10.105h-114.521l-10.105 10.105v84.205h-215.575v-171.774l138.112-138.112h289.675l138.112 138.112v357.049l-138.112 138.095h-202.106l-10.105 10.105v165.065h134.732v-80.843h215.591z",
    "6": "M350.307 727.583v70.737l-10.038 10.038h-114.588l-10.038-10.038v-165.065h212.145l138.112-138.028v-357.116l-138.112-138.112h-289.691l-138.095 138.112v747.86l138.095 138.112h289.691l138.112-138.112v-158.389zM215.575 417.681v-192.001l10.038-10.038h114.521l10.038 10.038v181.896l-10.038 10.038z",
    "7": "M579.366 1024h-579.366v-296.417h215.575v80.843h134.732l-202.090-808.425h229.043l202.106 808.425v215.575z",
    "8": "M565.898 569.261l-43.801-43.784 43.801-43.801v-343.564l-138.112-138.112h-289.675l-138.112 138.112v343.564l43.784 43.801-43.784 43.784v316.628l138.112 138.112h289.675l138.112-138.112zM215.575 643.361l10.038-10.038h114.521l10.038 10.038v154.959l-10.038 10.038h-114.454l-10.038-10.038zM350.323 225.68v181.896l-10.038 10.038h-114.605l-10.038-10.038v-181.896l10.038-10.038h114.521z",
    "9": "M215.575 323.37v-97.69l10.038-10.038h114.521l10.038 10.038v192.001h-212.078l-138.095 138.112v330.096l138.095 138.112h289.691l138.112-138.112v-747.777l-138.112-138.112h-289.691l-138.095 138.112v185.259zM350.307 633.255v165.065l-10.038 10.038h-114.588l-10.038-10.038v-154.959l10.038-10.038z",
    "A": "M347.709 168.542h-129.557l-16.048-168.542h-202.103l134.76 1024h296.413l134.687-1024h-202.103zM332.32 330.268l-49.39 518.668-49.39-518.815z",
    "B": "M498.297 458.067v-323.307l-134.54-134.76h-363.757v1024h363.757l134.54-134.76v-296.413l-67.343-67.343zM202.103 606.31h94.31v255.963h-94.31zM296.413 444.583h-94.31v-282.93h94.31z",
    "C": "M296.413 646.687v215.587h-94.31v-700.62h94.31v229.070h201.883v-255.963l-134.54-134.76h-228.997l-134.76 134.76v754.773l134.76 134.76h228.997l134.54-135.053v-242.553z",
    "D": "M363.757 1024l134.54-134.76v-754.773l-134.54-134.467h-363.757v1024zM296.413 862.273h-94.31v-700.62h94.31z",
    "E": "M404.207 862.273v161.727h-404.207v-1024h404.207v161.653h-202.103v282.93h161.653v161.727h-161.653v255.963h202.103z",
    "F": "M404.207 862.273v161.727h-404.207v-1024h202.103v444.583h161.653v161.727h-161.653v255.963h202.103z",
    "G": "M498.517 700.62v188.62l-134.76 134.76h-228.997l-134.76-134.76v-754.48l134.76-134.76h228.997l134.76 134.76v471.55h-249.295v-161.727h47.192v-282.93h-94.31v700.62h94.31v-161.653h202.103z",
    "H": "M296.413 1024v-417.69h-94.31v417.69h-202.103v-1024h202.103v444.583h94.31v-444.583h202.103v1024h-202.103z",
    "I": "M-0 0h202.103v1024h-202.103v-1024z",
    "J": "M296.413 1024v-862.347h-94.31v229.070h-202.103v-255.963l134.76-134.76h228.997l134.76 134.76v889.24h-202.103z",
    "K": "M552.45 0l-188.693 532.225 175.21 491.775h-215.587l-121.277-400.176v400.176h-202.103v-1024h202.103v428.682l134.76-428.682h215.587z",
    "L": "M202.103 161.653v862.347h-202.103v-1024h404.207v161.653h-202.103z",
    "M": "M471.55 1024l-107.793-673.727-107.793 673.727h-255.963v-1024h202.103v579.343l107.793-579.343h107.793l107.793 579.343v-579.343h202.103v1024h-256.037z",
    "N": "M309.897 1024v-512l-141.502 512h-168.395v-1024h202.103v512l141.428-512h168.468v1024h-202.103z",
    "O": "M363.757 1024l134.54-134.76v-754.773l-134.54-134.467h-228.997l-134.76 134.76v754.773l134.76 134.76zM296.413 862.273h-94.31v-700.62h94.31z",
    "P": "M498.297 498.297l-134.54-134.54h-161.653v-363.757h-202.103v1024h363.757l134.54-134.76zM296.413 862.273h-94.31v-337.083h94.31z",
    "Q": "M473.397 179.195l-35.853-35.853 35.853-143.342h-191.795l-12.81 51.169h-140.766l-128.026 128.026v717.058l128.026 128.026h217.554l127.817-128.305zM192.004 204.814h89.597v665.402h-89.597z",
    "R": "M296.413 0v444.583h-94.31v-444.583h-202.103v1024h363.757l134.54-134.76v-296.413l-67.343-67.343 67.343-67.417v-458.067zM202.103 606.31h94.31v255.963h-94.31z",
    "S": "M498.517 700.62v188.62l-134.76 134.76h-228.997l-134.76-134.76v-309.897l134.76-134.687h161.653v-283.003h-94.31v175.21h-202.103v-202.103l134.76-134.76h228.997l134.76 134.76v336.79l-134.76 134.76h-161.653v255.963h94.31v-161.653h202.103z",
    "T": "M485.033 1024h-485.033v-161.727h141.502v-862.273h202.103v862.273h141.428v161.727z",
    "U": "M296.413 1024v-862.347h-94.31v862.347h-202.103v-889.24l134.76-134.76h228.997l134.76 134.76v889.24h-202.103z",
    "V": "M431.173 0h-296.413l-134.76 1024h202.103l80.827-848.863 80.827 848.863h202.103l-134.687-1024z",
    "W": "M602.939 1024l-53.933-700.62-77.456 700.62h-141.428l-77.456-700.62-53.933 700.62h-198.733l104.422-1024h229.070l67.343 579.343 67.343-579.343h229.070l104.422 1024h-198.733z",
    "X": "M579.343 0l-175.137 538.967 161.653 485.033h-215.587l-60.602-242.553-60.602 242.553h-215.587l161.653-485.033-175.137-538.967h215.587l74.085 296.413 74.085-296.413h215.587z",
    "Y": "M363.757 1024h-13.483l-67.343-363.83-67.343 363.83h-215.587l181.878-660.243v-363.757h202.103v363.757l181.878 660.243h-202.103z",
    "Z": "M512 889.24l-67.417 134.76h-390.723v-161.727h229.070l-282.93-727.513 67.343-134.76h390.797v161.653h-229.070l282.93 727.587z",
};
var font_size = 24,
    panel_Hor_Adjustment = 1.5,
    font_Top_Adjustment = -17,
    tracking = 1,
    middleSplitAdjustment = -0.75,
    middleSpreadAdjustment = {
        left: 0.75,
        right: 0.75
    },
    small_Caps_Adjustment = {
        vertical: -170,
        horizontal: 0,
        scale_width: 0, // this effects with the numbers
        scale_height: 0, // this effects with the numbers
    },
    colors = {
        characters: {
            home: [
                "#FFFFFF", // white
            ],
            away: [
                "#0A0203", // black
            ]
        },
        numbers: {
            home: [
                "#FFFFFF", // white
                "#CE0E2D", // black
            ],
            away: [
                "#0A0203", // black
                "#CE0E2D", // red
            ]
        }
    },
    outlines = {
        characters: {
            width: 1.2
        },
        numbers: {
            width: 3
        }
    },
    special_Character_Adjustments = {
        period: {
            vertical: 8.5, // this moves it up from the bottom
            horizontal: 0,
            scale_width: 25.5,
            scale_height: 25.5,
        },
        hyphen: {
            vertical: -8,
            horizontal: -5.5,
            scale_width: 0,
            scale_height: -3,
        },
        apostrophe: {
            vertical: -0.75, // this is backwards
            horizontal: -1,
            scale_width: 0,
            scale_height: 0,
        }
    },
    number_Adjustments = {
        top: 20,
        left: -3.5,
        width: 122,
        height: 115,
        middle_Space: 5,
        oneOffset: 7
    };